export default __webpack_public_path__ + "static/ch-2fb344e2a7a4e4d327ca368ff1c94f10.svg";